import styled from 'styled-components'
import theme from 'theme_'
import CommonButton from 'components/Button/CommonButton'
import { Font14, Secondary } from 'components/Typography'
import { Form } from 'formik'
import Icon from '@mdi/react'

export const AddUserModalFormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  p {
    margin: 0;
  }
`

export const AddUserModalFieldWrapper = styled.div`
  display: block;
`

export const AddUserModalFormBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  padding: 0 16px;
  gap: 24px;
  @media ${theme.devices.tablet} {
    padding: 0;
  }
`

export const AddUserModalFormEmailBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const AddUserModalPermissionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 16px 16px;
  width: 100%;
  margin-bottom: 32px;
  border-radius: 8px;
  background: ${theme.colors.lighterGrey};
`

export const AddUserModalPermissionsTitle = styled(Secondary)`
  line-height: 24px;
  color: ${theme.colors.moreGrey};
`

export const AddUserModalFormButtonsWrapper = styled.div`
  display: flex;
  padding: 16px;
  gap: 20px;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40px;

  @media ${theme.devices.tablet} {
    width: 320px;
    padding: 0;
  }
`

export const AddUserModalCancelButton = styled(CommonButton)`
  background: transparent;
  width: 100%;
`

export const AddUserModalSubmitButton = styled(CommonButton)`
  width: 100%;
`

export const AddUserModalSpinnerWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`
export const AddUserModalInfo = styled.div`
  ${Font14};
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 32px;
  padding: 4px 16px 4px 8px;
  background: ${theme.colors.lighterGrey};
  border-radius: 8px;
`

export const AddUserModalSuccessInfo = styled(AddUserModalInfo)`
  background: ${theme.colors.successBack};
`

export const AddUserModalUnsuccessInfo = styled(AddUserModalInfo)`
  background: ${theme.colors.unsuccessBack};
`

export const AddUserModalInfoIcon = styled(Icon)`
  width: 20px;
  height: 20px;
  color: ${theme.colors.darkeyGrey};
  margin-right: 8px;
`

export const AddUserModalSuccessInfoIcon = styled(AddUserModalInfoIcon)`
  color: ${theme.colors.successGreen};
  margin-right: 8px;
`

export const AddUserModalUnsuccessInfoIcon = styled(AddUserModalInfoIcon)`
  color: ${theme.colors.error};
  margin-right: 8px;
`
